// Contrato de storage: user_instance/tenant são gravados pelo AuthService como
// btoa(toBinaryStr(JSON.stringify(x))). toBinaryStr só normaliza um caractere de
// aspas curvas antes do encode, então o inverso exato é JSON.parse(atob(raw)) —
// sem passo extra de decodificação UTF-8.

export interface Account {
  nomeConta: string;
  schema?: string;
  tipoLicenca?: string;
  acessoBloqueado?: boolean;
}

export interface LoggedUser {
  integrador?: boolean;
  contas?: Account[];
  [extra: string]: unknown;
}

// Campos exclusivos do tenant ativo (não fazem sentido na lista de contas do
// seletor), por isso ficam numa extensão em vez de no Account base.
export type TenantStorage = Account & {
  controleAcesso?: boolean;
  voipApp?: boolean;
  tipoVoipApp?: string;
  pacAutonomo?: boolean;
};

/** Inverso de btoa(toBinaryStr(JSON.stringify(x))); null em qualquer falha, nunca lança. */
export function decodeSessionValue<T>(raw: string | null): T | null {
  try {
    if (!raw) {
      return null;
    }
    const decoded = atob(raw);
    if (!decoded) {
      return null;
    }
    return JSON.parse(decoded) as T;
  } catch {
    return null;
  }
}

/** Decodifica sessionStorage['user_instance']; null quando ausente/ilegível. */
export function decodeUser(raw: string | null): LoggedUser | null {
  return decodeSessionValue<LoggedUser>(raw);
}

/** Decodifica sessionStorage['tenant']; null quando ausente/ilegível. */
export function decodeTenant(raw: string | null): TenantStorage | null {
  return decodeSessionValue<TenantStorage>(raw);
}
